import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Download, BarChart3 } from 'lucide-react';

export function AdminCategoriesTab({ categoryAnalytics, exportCategories }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-500">{categoryAnalytics.length} categorias encontradas</p>
        <Button size="sm" variant="outline" className="border-slate-300 text-xs" onClick={exportCategories} data-testid="export-categories-btn">
          <Download className="h-3.5 w-3.5 mr-1" /> CSV
        </Button>
      </div>
      <div className="grid gap-3">
        {categoryAnalytics.map(cat => (
          <Card key={cat.category} className="bg-white border border-slate-200" data-testid={`admin-cat-${cat.category}`}>
            <CardContent className="py-4">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <BarChart3 className="h-4 w-4 text-slate-400" />
                  <p className="font-semibold text-slate-900">{cat.category}</p>
                </div>
                <Badge className={`text-xs ${cat.conversion_rate >= 50 ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : cat.conversion_rate >= 20 ? 'bg-amber-50 text-amber-700 border-amber-200' : 'bg-red-50 text-red-700 border-red-200'}`}>
                  {cat.conversion_rate}% conversao
                </Badge>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-3 text-center">
                <div className="bg-slate-50 rounded-lg p-3"><p className="text-lg font-bold text-slate-900">{cat.total_coupons}</p><p className="text-xs text-slate-500">Cupons</p></div>
                <div className="bg-slate-50 rounded-lg p-3"><p className="text-lg font-bold text-slate-900">{cat.active_coupons}</p><p className="text-xs text-slate-500">Ativos</p></div>
                <div className="bg-blue-50 rounded-lg p-3"><p className="text-lg font-bold text-blue-700">{cat.total_claims}</p><p className="text-xs text-blue-500">Resgates</p></div>
                <div className="bg-emerald-50 rounded-lg p-3"><p className="text-lg font-bold text-emerald-700">{cat.total_validations}</p><p className="text-xs text-emerald-500">Validados</p></div>
                <div className="bg-amber-50 rounded-lg p-3"><p className="text-lg font-bold text-amber-700">{cat.pending_claims}</p><p className="text-xs text-amber-500">Pendentes</p></div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
